























































































































































































import SelectBranch from "@/components/custom/select/SelectBranch.vue";
import SelectCustomer from "@/components/custom/select/SelectCustomer.vue";
import SelectIcNumber from "@/components/custom/select/SelectIcNumber.vue";
import SelectMasterType from "@/components/custom/select/SelectMasterType.vue";
import { useBlob } from "@/hooks";
import useInvoiceRecurringReport, {
  FilterField,
} from "@/hooks/useInvoiceRecurringReport";
import MNotification from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { EnumBooleanInString } from "@/models/enums/global.enum";
import { ResponseListMaster } from "@/models/interface/contact.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { InvoiceRecurringReportResponseDto } from "@/models/interface/invoice-recurring-report/InvoiceRecurringReportResponseDto.interface";
import { masterServices } from "@/services/master.service";
import { FormUtils } from "@/utils/FormUtils";
import InvoiceRecurringReportTable from "@/views/invoice-recurring-report/components/InvoiceRecurringReportTable.vue";
import { FormModel } from "ant-design-vue";
import { Component, Mixins, Ref } from "vue-property-decorator";

@Component({
  components: {
    SelectMasterType,
    SelectBranch,
    SelectCustomer,
    SelectIcNumber,
    InvoiceRecurringReportTable,
  },
})
export default class InvoiceRecurringReport extends Mixins(MNotification) {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;

  @Ref("formModel")
  formModel!: FormModel;

  invoiceRecurringReports: InvoiceRecurringReportResponseDto[] = [];
  dataListStatus: ResponseListMaster[] = [];

  form: FilterField = {
    branch: undefined,
    customer: undefined,
    icNo: undefined,
    icStatus: undefined,
    invoiceAr: undefined,
    invoiceArNo: undefined,
    isBackup: undefined,
    unitCode: undefined,
    billingDate: [],
  };

  loading = {
    find: false,
    download: false,
    status: false,
  };

  created(): void {
    this.getListStatus();
  }

  get validationSchema() {
    return {
      billingDate: [FormUtils.mandatory(), FormUtils.maxOneYear()],
    };
  }

  booleanOptions: Array<Option> = [
    {
      label: this.$t("lbl_yes").toString(),
      key: 0,
      value: "true" as EnumBooleanInString,
    },
    {
      label: this.$t("lbl_no").toString(),
      key: 1,
      value: "false" as EnumBooleanInString,
    },
  ];
  invoiceArOptions: Array<Option> = [
    {
      label: this.$t("lbl_all").toString(),
      key: 0,
      value: "ALL" as EnumBooleanInString,
    },
    {
      label: this.$t("lbl_yes").toString(),
      key: 2,
      value: "YES" as EnumBooleanInString,
    },
    {
      label: this.$t("lbl_no").toString(),
      key: 1,
      value: "NO" as EnumBooleanInString,
    },
  ];

  handleReset(): void {
    this.formModel.resetFields();
  }

  filterOption(input, option): boolean {
    return (
      option.componentOptions.children[0].componentOptions.children[1].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  getListStatus() {
    const params: RequestQueryParamsModel = {
      name: "STATUS_INTERNAL_CONTRACT",
    };
    this.loading.status = true;
    masterServices
      .listMaster(params)
      .then(response => {
        this.dataListStatus = response.filter(
          dataFilter =>
            dataFilter.value !== "New" && dataFilter.value !== "Revised"
        );
      })
      .finally(() => (this.loading.status = false));
  }

  buildParamsDownload(state: FilterField): RequestQueryParamsModel {
    const { buildReportHeader, filterBy } = useInvoiceRecurringReport();
    const invoiceArParamValue = () => {
      if (this.form.invoiceAr === "ALL" || !this.form.invoiceAr)
        return undefined;
      if (state.invoiceAr === "YES") return true;
      return false;
    };

    return {
      params: buildReportHeader(state),
      invoiceAr: invoiceArParamValue(),
      search: filterBy({
        branch: state.branch,
        customer: state.customer,
        unitCode: state.unitCode,
        icNo: state.icNo,
        icStatus: state.icStatus,
        invoiceArNo: state.invoiceArNo,
        isBackup: state.isBackup,
        billingDate: state.billingDate,
      }),
    };
  }

  handleDownload(): void {
    const { download } = useInvoiceRecurringReport();
    const { toDownload } = useBlob();
    const params: RequestQueryParamsModel = this.buildParamsDownload(this.form);
    this.loading.download = true;
    download(params)
      .then(res => {
        toDownload(res, "invoice_recurring_report.xlsx");
      })
      .finally(() => {
        this.loading.download = false;
      });
  }

  onSubmit(): void {
    this.formModel.validate(valid => {
      if (!valid) return;

      this.loading.find = true;

      const { filterBy, findAll } = useInvoiceRecurringReport();
      const invoiceArParamValue = () => {
        if (this.form.invoiceAr === "ALL" || !this.form.invoiceAr)
          return undefined;
        if (this.form.invoiceAr === "YES") return true;
        return false;
      };

      const params = filterBy({
        branch: this.form.branch,
        customer: this.form.customer,
        unitCode: this.form.unitCode,
        icNo: this.form.icNo,
        icStatus: this.form.icStatus,
        invoiceArNo: this.form.invoiceArNo,
        isBackup: this.form.isBackup,
        billingDate: this.form.billingDate,
      });

      findAll({
        search: params,
        invoiceAr: invoiceArParamValue(),
      })
        .then(response => {
          this.invoiceRecurringReports = response;
        })
        .finally(() => {
          this.loading.find = false;
        });
    });
  }
}
